// extracted by mini-css-extract-plugin
export default {"badge":"UrgencyBadge_badge__JV0B8"};